import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-3898">
      <section className="py-16 bg-white" data-id="element-3899">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3900">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-3901">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-3902">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-3903">
            {/* Main Pages */}
            <div data-id="element-3904">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3905">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-3906">
                <li data-id="element-3907">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3908">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-3909">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3910">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-3911">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3912">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-3913">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3914">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-3915">
                <li data-id="element-3916">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3917">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-3918">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3919">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-3920">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3921">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-3922">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3923">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-3924">
                <li data-id="element-3925">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3926">
                    All Services
                  </Link>
                </li>
                <li data-id="element-3927">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3928">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-3929">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3930">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-3931">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3932">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-3933">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3934">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-3935">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3936">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-3937">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3938">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-3939">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3940">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-3941">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3942">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-3943">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3944">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-3945">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3946">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-3947">
                <li data-id="element-3948">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3949">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-3950">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3951">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-3952">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3953">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-3954">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3955">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-3956">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3957">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-3958">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3959">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-3960">
                <li data-id="element-3961">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3962">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-3963">
                  <Link to={`/${lang}/blog/dental-implants-cost-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3964">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-3965">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3966">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-3967">
                  <Link to={`/${lang}/blog/dental-treatment-uk-without-insurance`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3968">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-3969">
                  <Link to={`/${lang}/blog/toothache-london-what-to-do`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3970">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-3971">
                  <Link to={`/${lang}/blog/veneers-london-everything-you-need-to-know`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3972">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-3973">
                  <Link to={`/${lang}/blog/how-to-choose-dentist-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3974">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-3975">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3976">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-3977">
                <li data-id="element-3978">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3979">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-3980">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3981">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-3982">
                <li data-id="element-3983">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3984">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-3985">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3986">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-3987">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3988">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-3989">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-3990">
              <div className="flex items-center gap-2" data-id="element-3991">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-3992" />
                <span data-id="element-3993">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-3994">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-3995">
                <Button size="sm" className="gap-2" data-id="element-3996">
                  <Calendar className="w-4 h-4" data-id="element-3997" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-3998">
                <Button variant="whatsapp" size="sm" className="gap-2" data-id="element-3999">
                  <MessageCircle className="w-4 h-4" data-id="element-4000" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-4001">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-4002">
                  <Phone className="w-4 h-4" data-id="element-4003" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}